import { useLang } from "@/context/LanguageContext";
import { useSectionMeta } from "@/context/SiteConfigContext";
import { SectionHead, MaskWords, SectionButtons } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function HomeServices() {
  const { t } = useLang();
  const c = t.home_services || {};
  const groups = t.services?.groups || [];
  const meta = useSectionMeta("home_services");

  return (
    <section
      id="home_services"
      data-testid="home-services"
      className="bg-paper text-ink px-6 md:px-12 lg:px-20 py-28 md:py-40"
    >
      <SectionHead label={c.label} index="" />
      <div className="mt-10 md:mt-14 grid grid-cols-12 gap-6 items-end mb-14 md:mb-20">
        <MaskWords
          Tag="h2"
          text={c.title}
          className="col-span-12 lg:col-span-8 display uppercase text-[12vw] lg:text-[8vw] leading-[0.85] break-words"
        />
        <p className="col-span-12 lg:col-span-4 text-ink/65 leading-[1.6]">{c.intro}</p>
      </div>

      <div className="border-t border-ink/15">
        {groups.map((g, i) => (
          <Reveal key={i}>
            <div className="grid grid-cols-12 gap-6 md:gap-10 py-9 md:py-12 border-b border-ink/15 group items-start">
              <div className="col-span-12 lg:col-span-1 eyebrow text-ink/40 tnum">0{i + 1}</div>
              <h3 className="col-span-12 lg:col-span-4 display uppercase text-3xl md:text-5xl leading-[0.92] transition-transform duration-500 group-hover:translate-x-2">
                {g.key}
              </h3>
              <div className="col-span-12 lg:col-span-7">
                <p className="serif text-xl md:text-2xl leading-[1.3] text-ink/85 mb-5">{g.desc}</p>
                <ul className="flex flex-wrap gap-2">
                  {(g.items || []).map((it, k) => (
                    <li key={k} className="eyebrow border border-ink/20 rounded-full px-3.5 py-1.5 text-ink/65">
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-12 md:mt-16">
        <SectionButtons buttons={meta.buttons} />
      </div>
    </section>
  );
}
